import { useMutation } from 'react-query';
import http from 'infra/http';

function useDeleteTenantUsuario() {
  return useMutation('/v1/tenants/id/usuarios/usuarioId', ({tenantId, usuarioId}:{tenantId: string, usuarioId: string}) => 
    http.delete(`/v1/tenants/${tenantId}/usuarios/${usuarioId}`), {retry: false}
  );
}


export default useDeleteTenantUsuario
